export default __webpack_public_path__ + "assets/unitedstatesvirginislands-flag.png";